import Vue from "vue";
import Vuex from "vuex";
// import login from "./login";
// import menu from "./menu";
// import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store();
